import {FormControl} from '@angular/forms';

export class EmailValidators {

  static cannotContainSpace(control: FormControl) {

    if (control.value.indexOf(' ') >= 0) {
      return {cannotContainSpace: true};
    }
    return null;  // when no spaces
  }

  static invalidEmail(control: FormControl) {

    const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    if (control.value !== '' && (control.value.length <= 5 || !EMAIL_REGEXP.test(control.value))) {
      return {'invalidEmail': true};
    }

    return null;
  }
}






// WEBPACK FOOTER //
// ./src/app/validators/emailValidators.ts